import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "https://mybuildingalerts.com/";

const getAlertsByBuildingId = async (buildingId, device = false) => {
    try {
        const response = await axios.get(`${API_URL}/alerts/buildingalerts/${buildingId}`, {
            withCredentials: true, // To include the access_token cookie
            params: { device }
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch alerts", error);
        throw error;
    }
};

const getAlertById = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/alerts/${id}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch alert", error);
        throw error;
    }
};

// Get initial alert timestamp
const getInitialAlertTimestamp = async (alertId) => {
    try {
        const response = await axios.get(`${API_URL}/alerts/${alertId}/initial-timestamp`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch initial alert timestamp", error);
        throw error;
    }
};

// NEW: Get asset details by ID
const getAssetById = async (assetId) => {
    try {
        const response = await axios.get(`${API_URL}/alerts/asset/${assetId}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch asset details", error);
        throw error;
    }
};

const getBuildingById = async (buildingId) => {
    try {
        const response = await axios.get(`${API_URL}/buildings/${buildingId}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch alert", error);
        throw error;
    }
};

const getTenantsByBuildingId = async (buildingId) => {
    try {
        const response = await axios.get(`${API_URL}/tenants/building/${buildingId}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch tenants", error);
        throw error;
    }
};

const getBuildingsByUserId = async (userId) => {
    try {
        const response = await axios.get(`${API_URL}/buildings/user/${userId}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch alert", error);
        throw error;
    }
};

const getSuiteById = async (suiteId) => {
    try {
        const response = await axios.get(`${API_URL}/suites/${suiteId}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch suite", error);
        throw error;
    }
};

const getDevicesByIds = async (deviceIds) => {
    try {
        const response = await axios.get(`${API_URL}/devices/sensor?deviceIds=${deviceIds}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch alert", error);
        throw error;
    }
};

const updateAlertAssignedPersonnel = async (alertId, assignedPersonnel) => {
    try {
        const response = await axios.put(`${API_URL}/alerts/${alertId}`, {
            assignedPersonnel: assignedPersonnel
        }, {
            withCredentials: true 
        });
        return response.data;
    } catch (error) {
        console.error("Failed to update alert", error);
        throw error;
    }
};

const updateAlertStatus = async (alertId, alertStatus) => {
    try {
        const response = await axios.put(`${API_URL}/alerts/${alertId}`, {
            status: alertStatus
        }, {
            withCredentials: true 
        });
        return response.data;
    } catch (error) {
        console.error("Failed to update alert", error);
        throw error;
    }
};

const updateServiceRecord = async (recordId, updateType, newDescription) => {
    try {
        const { data: currentRecord } = await axios.get(`${API_URL}/servicerecords/${recordId}`, {
            withCredentials: true,
        });

        // Modify only the assignedPersonnel.description
        const updatedRecord = {
            ...currentRecord,
            updateType: {
                ...currentRecord.updateType,
                description: newDescription
            }
        };

        // PUT request with the updated record
        const response = await axios.put(`${API_URL}/servicerecords/${recordId}`, updatedRecord, {
            withCredentials: true,
        });

        return response.data;
    } catch (error) {
        console.error("Failed to update service record", error);
        throw error;
    }
};

const getServiceRecord = async (recordId) => {
    try {
        const response = await axios.get(`${API_URL}/servicerecords/${recordId}`, {
            withCredentials: true 
        });
        console.log(response);
        return response.data;
    } catch (error) {
        console.error("Failed to update service record", error);
        throw error;
    }
};

const getRecordIdFromAlert = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/alerts/${id}`, {
            withCredentials: true
        });
        if (response.data && response.data.serviceRecordId) {
            return response.data.serviceRecordId._id;
        } else {
            return null; 
        }
    } catch (error) {
        console.error("Failed to fetch alert", error);
        throw error;
    }
}

const getUserById = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/users/${id}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch user", error);
        throw error;
    }
};

const updateUser = async (userId, userData) => {
    try {
        const response = await axios.put(`${API_URL}/users/${userId}`, userData, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to update user", error);
        throw error;
    }
};

const getTenantById = async (tenantId) => {
    try {
        const response = await axios.get(`${API_URL}/tenants/${tenantId}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch tenant", error);
        throw error;
    }
};

const getAlertConfigByAlertId = async (alertId) => {
    try {
        const response = await axios.get(`${API_URL}/admin/alertconfig/alert/${alertId}`, {
            withCredentials: true // To include the access_token cookie
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch alert configuration", error);
        throw error;
    }
};

const AlertService = { 
    getAlertsByBuildingId, 
    getAlertById, 
    getInitialAlertTimestamp, 
    getAssetById, // NEW METHOD
    getBuildingById, 
    getTenantsByBuildingId,
    getBuildingsByUserId,
    getSuiteById,
    updateAlertAssignedPersonnel, 
    updateAlertStatus, 
    updateServiceRecord,
    getServiceRecord,
    getRecordIdFromAlert,
    getDevicesByIds,
    getUserById,
    updateUser,
    getTenantById,
    getAlertConfigByAlertId,
};

export default AlertService;